import { StyleProp } from "./StyleProp.mjs";
const DefaultDashStyle = StyleProp.defineEnum("tldraw:dash", {
  defaultValue: "draw",
  values: ["draw", "solid", "dashed", "dotted", "none"]
});
export {
  DefaultDashStyle
};
//# sourceMappingURL=TLDashStyle.mjs.map
